import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircleIcon, XIcon } from "lucide-react";
import { AR_NAMES, AR_CITIES } from "../lib/data";
const rand = <T,>(arr: T[]) => arr[Math.floor(Math.random() * arr.length)];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: "",
    city: "",
    mins: 3
  });
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setData({
        name: rand(AR_NAMES),
        city: rand(AR_CITIES),
        mins: Math.floor(Math.random() * 12) + 2
      });
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), 5000);
    };
    const firstTimer = setTimeout(show, 3500);
    const interval = setInterval(show, 13000);
    return () => {
      clearTimeout(firstTimer);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-167" data-mp="165pokll7jah6">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-sm" role="status" aria-live="polite" data-id="element-168" data-mp="164ejmig0zwoh">
          <div className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-3 shadow-2xl" data-id="element-169" data-mp="1aysiiutwclxw">
            <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-[#8bc34a]/15" data-id="element-170" data-mp="n8y6gfhej1ep">
              <CheckCircleIcon className="h-6 w-6 text-[#8bc34a]" data-id="element-171" data-mp="x519dnk2v42p" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-172" data-mp="x2ybkhcoo6nf">
              <p className="text-sm font-bold text-[#0f2c4a]" data-id="element-173" data-mp="s56eza13fwcw">
                {data.name} de {data.city}
              </p>
              <p className="text-xs text-slate-500" data-id="element-174" data-mp="28imvt0yjyrkj">
                acaba de comprar Profe Fútbol Resuelto · hace {data.mins} min
              </p>
            </div>
            <button type="button" onClick={() => setVisible(false)} aria-label="Cerrar aviso" className="flex-shrink-0 text-slate-400" data-id="element-175" data-mp="2apctz6lmvdl3">
              <XIcon className="h-4 w-4" data-id="element-176" data-mp="2knsl39knumul" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}